import * as React from 'react';
import toast from 'cogo-toast';
import dayjs from 'dayjs';
import { Page, Card, Icon } from 'tabler-react';
import { Link } from 'react-router-dom';
import PageComponent from '../PageComponent';
import If from '../../components/if';
import Request from '../../shared/request';
import './vas.scss';
import store from '../../shared/store';

const PAY_METHODS = {
  WECHAT: {
    icon: 'ri-wechat-fill',
    name: '微信',
  },
  ALIPAY: {
    icon: 'ri-alipay-fill',
    name: '支付宝',
  },
  PAYPAL: {
    icon: 'ri-paypal-fill',
    name: 'Paypal',
  },
};

class VasIndex extends PageComponent {
  state = {
    plans: [],
    plan: null,
    paymethod: '',
    loading: false,
    qrcodeBase64: '',
    planId: null,
    checking: false,
    days: 0,
  };

  async componentDidMount() {
    const plans = await Request.call('getVasPlans');
    this.setState({ plans });
    let planId;
    let plan = plans[0];
    try {
      const URLsearch = new URLSearchParams(window.location.search);
      planId = URLsearch.get('planId');
    } catch (error) {
      // noop
    }
    if (planId) {
      this.setState({ planId });
      const defaultPlan = plans.find(p => p.planId === planId);
      plan = defaultPlan || plan;
    }
    this.changePlan(plan);
  }

  changePlan = plan => {
    this.setState({ plan, paymethod: plan.paidType[0], days: plan.days });
    this.planDays = plan.days;
  };

  setDays = days => {
    this.setState({ days });
  };

  changePayMethod = paymethod => {
    this.setState({ paymethod });
  };

  changeDay = () => {
    this.setState({ days: this.planDays });
  };

  daysClassName = days => {
    if (this.state.plan && this.state.plan.days <= 0) {
      return 'tag disable';
    }
    if (this.state.plan && days > this.state.plan.days) {
      return 'tag disable';
    }
    if (days === this.state.days) {
      return 'tag active';
    }
    return 'tag';
  };

  totalPrice = () => {
    if (this.state.paymethod === 'PAYPAL') {
      return `$ ${
        this.state.plan
          ? (this.state.plan.dayPriceUSD * this.state.days).toFixed(2)
          : '--'
      }`;
    }
    return `¥ ${
      this.state.plan
        ? (this.state.plan.dayPrice * this.state.days).toFixed(2)
        : '--'
    }`;
  };

  checkOrder = async () => {
    if (this.state.confirmInfo) {
      this.setState({ checking: true });

      const status = await Request.call('confirmPayment', {
        confirmInfo: this.state.confirmInfo,
        paidType: 'WECHAT',
      });
      this.setState({ checking: false });
      if (status) {
        this.props.history.push('/dashboard');
        toast.success('购买成功');
      }
    } else {
      toast.warn('请发起支付后再确认订单');
    }
  };

  startPaypal = async () => {
    this.setState({ loading: true });
    const payInfo = await Request.call('createVasPaypalPayment', {
      planId: this.state.plan.planId,
      paidType: this.state.paymethod,
      days: this.state.days,
    });
    this.setState({ loading: false });
    if (payInfo.redirectUrl) {
      // window.location.href = payInfo.redirectUrl;
      window.open(payInfo.redirectUrl);
    }
  };

  startPay = async () => {
    if (this.state.paymethod === 'PAYPAL') {
      this.startPaypal();
      return;
    }
    this.setState({ loading: true });
    const data = await Request.call('createOrder', {
      category: 'vas',
      planId: this.state.plan.planId,
      paidType: this.state.paymethod,
      days: this.state.days,
    });
    this.setState({ loading: false });
    if (data.wechat && data.wechat.qrcodeUrl) {
      this.setState({
        qrcodeBase64: data.wechat.qrcodeUrl,
        confirmInfo: data.confirmInfo,
      });
    }
    if (data.alipay && data.alipay.redirectUrl) {
      window.open(data.alipay.redirectUrl);
    }
  };

  renderBandwidthTips = () => {
    if (store.user.planExpiredAt < Date.now()) {
      return '';
    }
    return (
      <div className="time-tips">
        <div>
          <div className="mb-time">
            <span>会员到期:</span>
            <span>{dayjs(store.user.planExpiredAt).format('YYYY.MM.DD')}</span>
          </div>
          {store.user.bandwidthExpiredAt ? (
            <div className="vas-time">
              <span>增值套餐到期:</span>
              <span>
                {store.user.bandwidthExpiredAt > Date.now()
                  ? dayjs(store.user.bandwidthExpiredAt).format('YYYY.MM.DD')
                  : '已过期'}
              </span>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  };

  renderClientTips = () => {
    if (store.user.planExpiredAt < Date.now()) {
      return '';
    }
    return (
      <div className="time-tips">
        <div>
          <div className="mb-time">
            <span>会员到期:</span>
            <span>{dayjs(store.user.planExpiredAt).format('YYYY.MM.DD')}</span>
          </div>
          {store.user.bandwidthExpiredAt ? (
            <div className="vas-time">
              <span>增值套餐到期:</span>
              <span>
                {store.user.extraClientsExpiredAt > Date.now()
                  ? dayjs(store.user.extraClientsExpiredAt).format('YYYY.MM.DD')
                  : '已过期'}
              </span>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  };

  renderTips() {
    if (this.state.plan) {
      if (this.state.plan.category === 'device') {
        return this.renderClientTips();
      }
      return this.renderBandwidthTips();
    }
    return '';
  }

  render() {
    return (
      <Page.Content className="page-vas page-bind">
        <Card>
          <div
            className={`pay-qrcode ${this.state.qrcodeBase64 ? '' : 'hidden'}`}>
            <Card className="content">
              <Card.Header>
                <Card.Title>
                  {this.state.paymethod &&
                    PAY_METHODS[this.state.paymethod].name}
                  支付
                </Card.Title>
                <div
                  className="closed"
                  onClick={() => this.setState({ qrcodeBase64: '' })}>
                  <Icon name="x" />
                </div>
              </Card.Header>
              <Card.Body>
                <div className="qrcode">
                  <img src={this.state.qrcodeBase64} alt="" />
                  <div className="tips">
                    <i className="ri-qr-scan-line" />
                    请使用
                    {this.state.paymethod &&
                      PAY_METHODS[this.state.paymethod].name}
                    扫码支付
                  </div>
                </div>
                <div className="right">
                  <span className="title">预计支付金额</span>
                  <div className="vas-price">{this.totalPrice()}</div>
                  <div className="tips">付款后，请点击下方[我已支付]按钮</div>
                </div>
              </Card.Body>
              <div className="bottom">
                <div
                  className="btn-vas-close"
                  onClick={() => this.setState({ qrcodeBase64: '' })}>
                  取消
                </div>
                <div
                  className={`btn-vas-check ${
                    this.state.checking ? 'loading' : ''
                  }`}
                  onClick={() => this.checkOrder()}>
                  {this.state.checking ? '确认支付中...' : '我已完成支付'}
                </div>
              </div>
            </Card>
          </div>

          <Card.Header>
            <Link to="/dashboard">
              <i className="fa fa-angle-left" />
              <span>返回</span>
            </Link>
            <Card.Title>购买增值服务</Card.Title>
          </Card.Header>
          <div className="content">
            <div className="product">
              {this.state.plan ? (
                <div className="thumb">
                  <img
                    src={this.state.plan && this.state.plan.cover}
                    alt={this.state.plan.title}
                  />
                </div>
              ) : (
                <div className="thumb loading-thumb" />
              )}

              <div className="des">
                <div className="name">
                  {this.state.plan ? this.state.plan.cateName : '...'}
                </div>

                <div className="vas-type">
                  <div className="label">套餐类型:</div>

                  {this.state.planId ? (
                    <div className="choose-tag">
                      <div className="tag active">
                        {this.state.plan ? this.state.plan.title : '...'}
                      </div>
                    </div>
                  ) : (
                    <div className="choose-tag">
                      {this.state.plans &&
                        this.state.plans.map(plan => (
                          <div
                            onClick={() => this.changePlan(plan)}
                            className={`tag ${
                              this.state.plan &&
                              plan.planId === this.state.plan.planId
                                ? 'active'
                                : ''
                            }`}>
                            {plan.title}
                          </div>
                        ))}
                    </div>
                  )}
                </div>

                <div className="vas-time">
                  <div className="label">购买时长:</div>
                  <div className="choose-tag">
                    <div
                      onClick={() => this.setState({ days: this.planDays })}
                      className={this.daysClassName(this.planDays)}>
                      补齐时长
                    </div>
                    <div
                      onClick={() => this.setState({ days: 30 })}
                      className={this.daysClassName(30)}>
                      30天
                    </div>
                    <div
                      onClick={() => this.setState({ days: 90 })}
                      className={this.daysClassName(90)}>
                      90天
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="product-info">
              {this.state.plan && this.renderTips()}
              <div className="title">商品说明:</div>
              <div className="des">
                {this.state.plan ? (
                  this.state.plan.features.map(feature => <p>{feature}</p>)
                ) : (
                  <div className="loading-feature">加载中...</div>
                )}
              </div>
            </div>
            <div className="product-payment-method">
              <div className="title">选择支付方式</div>
              <div className="payment-method">
                {this.state.plan ? (
                  this.state.plan.paidType.map(key => (
                    <div
                      onClick={() => this.changePayMethod(key)}
                      className={`item ${
                        this.state.paymethod === key ? 'active' : ''
                      }`}>
                      <i className={`${PAY_METHODS[key].icon}`} />
                      <span>{PAY_METHODS[key].name}</span>
                    </div>
                  ))
                ) : (
                  <div>支付方式加载中...</div>
                )}
              </div>
            </div>
            <If
              condition={
                this.state.plan &&
                this.state.plan.dayPrice * this.state.days <= 0
              }>
              <div className="product-payment-price">
                <div className="price">
                  <span>已购买</span>
                </div>
              </div>
            </If>
            <If
              condition={
                this.state.plan &&
                this.state.plan.dayPrice * this.state.days > 0 &&
                this.state.plan.canBuy
              }>
              <div className="product-payment-price">
                <div className="price">
                  <span>应付总金额</span>
                  <div className="num">{this.totalPrice()}</div>
                </div>
                <div className="payment-btn" onClick={this.startPay}>
                  {this.state.loading ? ' 支付中...' : '立即支付'}
                </div>
              </div>
            </If>
            <If condition={this.state.plan && !this.state.plan.canBuy}>
              <a className="product-payment-price" href="/buy">
                {this.state.plan ? this.state.plan.warnMessage : '-'}
              </a>
            </If>
          </div>
        </Card>
      </Page.Content>
    );
  }
}

export default VasIndex;
